// import { supportedLocales, rollupLocales } from './supportedLocales';
import { supportedLocales, rollupCompiledLocales } from './supportedLocales';

export const intlConfig = {
  fallbackLocale: 'en',
  globalLocale: 'global',
  supportedLocales: supportedLocales,
  // rollupLocales: rollupLocales,
  rollupLocales: rollupCompiledLocales,
};

export default intlConfig;
